import type { GeneratedLesson } from "../types";
import { Target } from "lucide-react";

interface ObjectivesSectionProps {
  lesson: GeneratedLesson;
}

export function ObjectivesSection({ lesson }: ObjectivesSectionProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Target className="w-5 h-5" style={{ color: "var(--primary-color)" }} />
        <h3
          className="text-xl font-bold"
          style={{ color: "var(--text-primary)" }}
        >
          Objetivos de Aprendizado
        </h3>
      </div>

      <ul className="space-y-2">
        {lesson.objectives.map((objective, idx) => (
          <li
            key={idx}
            className="flex items-start gap-3 p-3 rounded-lg"
            style={{ backgroundColor: "var(--bg-accent)" }}
          >
            <span
              className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold"
              style={{
                backgroundColor: "var(--primary-color)",
                color: "white",
              }}
            >
              {idx + 1}
            </span>
            <span style={{ color: "var(--text-primary)" }}>{objective}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
